export type FiboProjectionTargets = {
  t1: number
  t2: number
  t3: number
}

export type FiboProjectionTrend = 'long' | 'short'

export function computeFiboProjectionTargets(params: {
  hi: number
  lo: number
  trend: FiboProjectionTrend
}): FiboProjectionTargets | null {
  const hi = Number(params.hi)
  const lo = Number(params.lo)
  if (!Number.isFinite(hi) || !Number.isFinite(lo) || hi <= lo) return null

  const range = hi - lo
  if (!Number.isFinite(range) || range <= 0) return null

  if (params.trend === 'long') {
    return {
      t1: hi,
      t2: hi + 0.618 * range,
      t3: hi + 1.618 * range,
    }
  }

  return {
    t1: lo,
    t2: lo - 0.618 * range,
    t3: lo - 1.618 * range,
  }
}

